import {
  ApplicationState,
  StateStoreOrVoid
} from '../../../../core/types/application-state';
import { DataLoader } from '../../../../core/types/data-loader';
import { mergeTyped } from '../../../../core/util';
import { loadUser } from '../../../shared/loaders';
import { accountTypes, chargeTypes, sourceTypes } from '../../../shared/utils';
import {
  analyticsDataLayer,
  dispatchPageLoad
} from '../../../../analytics/analytics-helper';
import {
  accountTypesAnalytics,
  productTypesAnalytics
} from '../../../../analytics/util';

export const makeLoadProfileData = (): DataLoader =>
  async function loadProfileData(
    a: ApplicationState
  ): Promise<StateStoreOrVoid> {
    const userResults = await loadUser(a);

    return {
      ...mergeTyped<StateStoreOrVoid>(userResults, {
        accountType: accountTypes.JOINT,
        chargeType: chargeTypes.TRANSFER
      })
    };
  };

export const updateAnalytics: DataLoader = async (
  { store },
  flowProps
): Promise<StateStoreOrVoid> => {
  analyticsDataLayer({
    accountType: accountTypesAnalytics.TAXABLE.JOINT.TRANSFER,
    productType: productTypesAnalytics.MUTUAL_FUND,
    sourceType: sourceTypes.DEFAULT,
    userType:
      store?.authenticated && !store?.loadedData?.newUserCreated
        ? 'Existing'
        : 'New',
    amount: store?.amount,
    isComplete: Boolean(flowProps?.analytics?.isComplete),
    clientTier: store?.summitData?.assetTierID?.toString()
  });
  dispatchPageLoad(flowProps?.analytics.pageName);
};
